'use client';

import React from 'react';
import Icon from '@/components/ui/AppIcon';

interface WhatsAppButtonProps {
  phoneNumber?: string;
  message?: string;
  className?: string;
}

const WhatsAppButton = ({
  phoneNumber = '+919876543210',
  message = 'Hi! I would like to discuss a project with DesiSocio.',
  className = '',
}: WhatsAppButtonProps) => {
  const handleWhatsAppClick = () => {
    const encodedMessage = encodeURIComponent(message);
    const whatsappUrl = `https://wa.me/${phoneNumber.replace(/[^0-9]/g, '')}?text=${encodedMessage}`;
    window.open(whatsappUrl, '_blank', 'noopener,noreferrer');
  };

  return (
    <button data-component-id="src/components/common/WhatsAppButton.tsx:24:4" data-component-path="src/components/common/WhatsAppButton.tsx" data-component-line="24" data-component-end-line="35" data-component-file="WhatsAppButton.tsx" data-component-name="button" data-component-content="%7B%22elementName%22%3A%22button%22%7D"
      onClick={handleWhatsAppClick}
      className={`fixed bottom-6 right-6 z-50 w-14 h-14 bg-success hover:bg-success/90 rounded-full shadow-elevated flex items-center justify-center transition-all duration-300 hover:scale-110 animate-pulse-scale group ${className}`}
      aria-label="Contact us on WhatsApp"
    >
      <Icon data-component-id="src/components/common/WhatsAppButton.tsx:29:6" data-component-path="src/components/common/WhatsAppButton.tsx" data-component-line="29" data-component-end-line="33" data-component-file="WhatsAppButton.tsx" data-component-name="Icon" data-component-content="%7B%22elementName%22%3A%22Icon%22%2C%22name%22%3A%22ChatBubbleLeftRightIcon%22%2C%22className%22%3A%22text-success-foreground%20group-hover%3Ascale-110%20transition-transform%20duration-300%22%7D"
        name="ChatBubbleLeftRightIcon"
        size={28}
        className="text-success-foreground group-hover:scale-110 transition-transform duration-300"
      />
      <span data-component-id="src/components/common/WhatsAppButton.tsx:34:6" data-component-path="src/components/common/WhatsAppButton.tsx" data-component-line="34" data-component-end-line="34" data-component-file="WhatsAppButton.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%2C%22className%22%3A%22absolute%20-top-1%20-right-1%20w-4%20h-4%20bg-error%20rounded-full%20animate-pulse%22%7D" className="absolute -top-1 -right-1 w-4 h-4 bg-error rounded-full animate-pulse" />
    </button>
  );
};

export default WhatsAppButton;